<template>
    <div class="row">
        <div class="col-lg-12 m-b-20 client-blacklist-title">
            <!--<h3>Client's Black List Data</h3>-->
            {{ title }}
        </div>
        <div class="col-lg-8">
            <b-form v-if="status == 'completed'">
                <base-upload-file
                    :type="type"
                    :upload-file-css="uploadFileCss"
                    :import-file-run="importFileRun"
                    :accept-file="acceptFile"
                    :label-val="'UPLOAD FILES'"
                    @show-progress="showProgress"
                    @uploaded="uploaded"
                >
                    <slot>
                        <div class="file-detail">
                            <div class="file-title">
                                <h5>
                                    {{deltaStatus}}
                                </h5>
                                <p>
                                    Supported file formats are XLS, XLSX and CSV
                                </p>
                            </div>
                        </div>
                    </slot>
                </base-upload-file>
                <base-toast></base-toast>
                <div class="file-activity">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <div class="file-progress">
                        <h6>Uploading</h6>
                        <b-progress
                            :value="progressValue"
                            :max="max"
                            class="mb-3"
                        ></b-progress>
                        <span>{{ progressValue }}% completed</span>
                    </div>
                </div>
                <div
                    v-if="type == 'import'"
                    class="file-upload-info"
                >
                    <div class="file-last-update">
                        <p>
                            Last updated on
                            <span>{{
                                updated_date ? updated_date : 'Not updated'
                            }}</span>
                        </p>
                    </div>
                    <div v-if="updated_date" class="download-current-file">
                        <button
                            class="btn btn-link"
                            @click.prevent="startDownload()"
                        >
                            <i class="icon-export"></i>

                            <span class="btn-text"
                                >Download Current Data File</span
                            >
                        </button>
                    </div>
                </div>
            </b-form>
            <div v-if="type == 'deltaListUploading'">
                <div
                    class="delta-progress-update"
                    v-if="
                        deltaProcessData &&
                        deltaProcessData.processStatus &&
                        deltaProcessData.processStatus !== 'completed'
                    "
                >
                    <p>
                        Delta Process Status
                        <b style="color: #3c1559">{{
                            deltaProcessData
                                ? deltaProcessData.processStatus
                                : 'Not updated'
                        }}</b>
                        <br />
                        <span v-if="!deltaProcessData.inScreeningData">
                            Process Initated On
                            <b style="color: #3c1559">{{
                                deltaProcessData && deltaProcessData.createdAt ? formatDate(deltaProcessData.createdAt) : 'Not Available'
                            }}</b>
                        </span>
                    </p>
                    <b v-if="deltaProcessData.inScreeningData">
                        PROCESSING AND UPLOADING FILE INTO DATABASE
                    </b>
                </div>
                <div
                    class="delta-progress-update"
                    v-if="
                        deltaProcessData &&
                        deltaProcessData.processStatus &&
                        deltaProcessData.processStatus == 'completed'
                    "
                >
                    <p>
                        Last Updated On
                        <b style="color: #3c1559">{{
                            deltaProcessData && deltaProcessData.updatedAt ? formatDate(deltaProcessData.updatedAt) : 'Not Available'

                        }}</b>
                    </p>
                </div>
                <div
                    v-if="
                        deltaProcessData &&
                        deltaProcessData.processStatus !== 'completed' &&
                        type == 'deltaListUploading' &&
                        !deltaProcessData.inScreeningData
                    "
                    class="file-last-update"
                >
                    <span>{{
                        deltaProcessData.completedCustomerCount +
                        ' customers completed out of ' +
                        deltaProcessData.totalCustomerCount
                    }}</span
                    ><br />
                    <b-progress
                        :value="deltaProcessData.completedCustomerCount"
                        :max="deltaProcessData.totalCustomerCount"
                        class="mb-3"
                    ></b-progress
                    ><br />
                    <span
                        >{{
                            (
                                (deltaProcessData.completedCustomerCount /
                                    deltaProcessData.totalCustomerCount) *
                                100
                            ).toFixed(2)
                        }}% completed</span
                    >
                    <span v-if="estimatedTTC !== ''"
                        ><br />Estimated Time To Completion:
                        <b style="color: #3c1559">{{ estimatedTTC }}</b></span
                    >
                </div>
            </div>
            <div v-if="status == 'in-process'" class="upload-files h-100px">
                <div class="file-detail">
                    <div class="file-title">
                        <h5 class="m-b-0px">
                            File in process, you can't upload the file.
                        </h5>
                    </div>
                </div>
            </div>
            <!-- When data is loading -->
            <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        </div>

        <div
            v-if="
                type == 'bulkCustomersOnboarding'
            "
            class="col-lg-4"
        >
            <div class="download-template">
                <h5>Download Template</h5>
                <p>
                    You can bulk upload your customers by downloading the template below, adding your customer data according to the template and then uploading the excel file above.
                </p>
                <div class="link-action">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <button
                            class="btn btn-link"
                            @click.prevent="downloadTemplate('users','templateBulk.xlsx')"
                    >
                        <span class="btn-text"
                        >Download Template for Individual</span
                        >
                    </button>
                </div>
                <div class="link-action" v-if="user.kyb">
                    <div class="file-thumbnail">
                        <excel-icon></excel-icon>
                    </div>
                    <button
                            class="btn btn-link"
                            @click.prevent="downloadTemplate('users','templateBulkCompany.xlsx')"
                    >
                        <span class="btn-text"
                        >Download Template for Company</span
                        >
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import excelIcon from '@/components/icons/ExcelIcon.vue'
//import black from '@/components/icons/Black.json'
import axios from 'axios'
import request from '@/utils/request'

const apiUrl_data = process.env.VUE_APP_API_URL
const headers = {
    Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
}
export default {
    components: {
        excelIcon,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            default: 'Idenfo Black List Data',
        },
        type: {
            default: 'import',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            uploadFileCss: true,
            blacklist: false,
            progressValue: 0,
            max: 100,
            form: {
                file: null,
            },
            updated_date: null,
            url: '',
            import_statistics_data: '',
            DowmLoadFileName: '',
            status: '',
            importFileRun: true,
            acceptFile: '.xlsx,.csv,.xls',
            deltaStatus: 'Click here to upload the data file.',
            deltaProcessData: null,
            intervalId: true,
            estimatedTTC: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'user',
            'dataSegmentId',
            'formBuilderList',
            'loading',
            'showPageLoader',
        ]),
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        deltaStatus(value)
        {
            console.log('delta label',value)
        },
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('showPageLoader', true)
                this.importStatisticsData()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.$store.commit('showPageLoader', true)
        this.importDeltaStatusProgress()
        this.importStatisticsData()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    beforeDestroy: function () {
        console.log('beforeDestroy()')
        this.intervalId = false
    },
    methods: {
        formatDate (date){
            let dt = this.$moment(date).format("DD/MM/YYYY HH:mm:ss")
            return dt
        },
        showProgress(value) {
            this.progressValue = value
            if (this.type == 'bulkCustomersOnboarding') {
                this.$emit('show-progress', value)
            }
        },
        uploaded(value) {
            this.importDeltaStatusProgress()
        },
        async importDeltaStatusProgress() {
            if (this.type == 'deltaListUploading') {
                try {
                    let response = await axios.get(
                        apiUrl_data + 'screening-data/returnDeltaStatus',
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    if (!response.data.data.message) {
                        this.deltaProcessData = response.data.data
                        this.status = response.data.data.processStatus
                            ? response.data.data.processStatus
                            : 'completed'
                        if (
                            response.data.data.processStatus == 'in-progress' &&
                            this.intervalId
                        ) {
                            if (
                                response.data.data.inScreeningData &&
                                response.data.data.errorLog == ''
                            ) {
                            } else if (
                                !response.data.data.inScreeningData &&
                                response.data.data.errorLog != ''
                            ) {
                            } else {
                                let totalTimeMs =
                                    this.deltaProcessData.averageTimeMs *
                                    (this.deltaProcessData.totalCustomerCount -
                                        this.deltaProcessData
                                            .completedCustomerCount)
                                this.estimatedTTC = this.msToTime(totalTimeMs)
                            }
                            setTimeout(() => {
                                this.importDeltaStatusProgress()
                            }, 500)
                        }
                    } else {
                        this.status='completed'
                        this.deltaProcessData = null
                    }
                } catch (e) {
                    this.status='completed'
                    this.deltaProcessData = null
                }
            }
            else {
                this.status='completed'
            }
        },
        msToTime(duration) {
            var seconds = Math.floor((duration / 1000) % 60),
                minutes = Math.floor((duration / (1000 * 60)) % 60),
                hours = Math.floor((duration / (1000 * 60 * 60)) % 24)

            hours = hours < 10 ? '0' + hours : hours
            minutes = minutes < 10 ? '0' + minutes : minutes
            seconds = seconds < 10 ? '0' + seconds : seconds

            return hours + ':' + minutes + ':' + seconds
        },
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', this.DowmLoadFileName)
            document.body.appendChild(link)
            link.click()
        },

        startDownload() {
            axios({
                method: 'get',
                url: this.url,
                responseType: 'arraybuffer',
                headers: headers,
            })
                .then((response) => {
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        },
        async downloadTemplate(dir,file) {

            let fileUrl = dir +'/'+ file

            axios({
                method: 'get',
                url: process.env.VUE_APP_FILE_SERVICE_URL + fileUrl,
                responseType: 'arraybuffer',
            })
                .then((response) => {
                    this.DowmLoadFileName=file
                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
        }, // End of downloadFile() method
        async importStatisticsData() {
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId && this.type !== 'deltaListUploading') {
                try {
                    let response = await axios.get(
                        apiUrl_data +
                            'screening-data/import-statistics/' +
                            dataSegmentId,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    this.updated_date = response.data.data.lastUpdatedAt
                    this.url = response.data.data.fileURL
                    this.DowmLoadFileName = response.data.data.fileName
                    this.status = response.data.data.status
                    if(this.status!='completed' && this.status!='in-process')
                    {
                        this.deltaStatus = 'Last uploaded delta file contains some error, please upload again'
                    }
                } catch (e) {
                    this.updated_date = null
                    this.url = ''
                    this.DowmLoadFileName = ''
                    this.status = 'completed'
                }
            }

            this.$store.commit('showPageLoader', false)
        },
    }, // End of Component > watch
} // End of export default
</script>
